import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Paper } from "@material-ui/core";

import Existing from "./components/Existing";
import FormikSignIn from "./components/FormikSignIn";
import countryCodes from "../../json/countryISDCode.json";

// const options = ["+91", "+92", "+93", "+94"];
const options = countryCodes.codes;

function getModalStyle() {
  const top = 50;
  const left = 50;
  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 450,
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2, 4, 3),
    borderRadius: "3px",
    boxShadow:
      "0px 24px 18px rgba(23, 43, 77, 0.04), 0px 35px 24px rgba(23, 43, 77, 0.08)",
    outline: "none",
    [theme.breakpoints.only("xs")]: {
      width: "90%",
    },
  },
  reSend: {
    cursor: "pointer",
    float: "right",
  },
  Heading: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    color: theme.palette.KenColors.neutral100,
    textAlign: "left",
    textTransform: "uppercase",
    marginBottom: 24,
  },
}));

export default function SimpleModal(props) {
  const classes = useStyles();
  const {
    handleClose,
    open,
    retrieve,
    programID,
    notify,
    handleSnackbarOpen,
    instituteId,
    programName,
    currentRow,
    applyingForMe,
    relationWithApplicant,
  } = props;
  //console.log('props in Modal',props)
  //console.log('currentRow in Modal',currentRow)
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [otp, setOtp] = React.useState();
  const [signActive, setSignActive] = React.useState(true);
  const [existingActive, setExistingActive] = React.useState(false);
  const mobileNumber = localStorage.getItem("userPhone"); //JSON.parse(localStorage.getItem("userPhone"));

  React.useEffect(() => {
    if (retrieve) {
      toggle();
    }
    if (otp) {
      alert(`Please note down the OTP for further process. The OTP is ${otp}`);
    }
    if (mobileNumber && !existingActive) {
      toggle();
    }
  }, [otp]);

  const toggle = () => {
    setSignActive(!signActive);
    setExistingActive(!existingActive);
  };
  const body = (
    <Paper style={modalStyle} className={classes.paper} elevation={0}>
      {signActive === true && (
        <FormikSignIn
          currentRow={currentRow}
          instituteId={instituteId}
          programName={programName}
          programID={programID}
          options={options}
          toggle={toggle}
          notify={notify}
          handleClose={handleClose}
          handleSnackbarOpen={handleSnackbarOpen}
        />
      )}
      {existingActive === true && (
        <Existing
          currentRow={currentRow}
          programID={programID}
          instituteId={instituteId}
          programName={programName}
          options={options}
          retrieve={retrieve}
          toggle={toggle}
          notify={notify}
          handleClose={handleClose}
          handleSnackbarOpen={handleSnackbarOpen}
          applyingForMe={applyingForMe}
          relationWithApplicant={relationWithApplicant}
        />
      )}
      <SimpleModal submitted={false} />
    </Paper>
  );

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        {body}
      </Modal>
    </div>
  );
}
